import { useState } from "react";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import { InputField, Submitbtn } from "../../../Component";
import AddMoreBtn from "../../../Component/addMoreBtn";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { addAgeGroup, uploadAgeGroupImage } from "../adminSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import ImgPickerAndViewer from "../../../Component/imgPickerAndViewer";
import {
  containsNumber,
  validateAgeGrp,
  validateIsFileImageType,
} from "../../../Utils/validators";
import { validateIsFileImageTypeErrMsg } from "../../../Utils/errorMsg";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
const AgeGroup = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const initialVal = [
    {
      name: "",
      ageGroup: "",
      frontImage: "",
      backImage: "",
      order: "",
      seoName: "",
      frontImagePreview: "",
      backImagePreview: "",
    },
  ];
  const [ageRangeArr, setAgeRangeArr] = useState<any>(initialVal);
  const onPressAdd = () => {
    setAgeRangeArr([...ageRangeArr, initialVal[0]]);
  };
  const handleClose = (index: any) => {
    const newArrr = [...ageRangeArr];
    if (index > -1) {
      newArrr.splice(index, 1);
    }
    setAgeRangeArr(newArrr);
  };

  function onchangeRange(val: any, index: any, key: any) {
    let newArr = JSON.parse(JSON.stringify(ageRangeArr));
    const mediaTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
    if (key === "frontImage") {
      if (!validateIsFileImageType(val)) {
        return;
      } else {
        const reader = new FileReader();
        const file = val.target.files[0];
        if (!mediaTypes.includes(file.type)) {
          console.error("Unsupported file type:", file.type);
          return;
        }
        reader.onloadend = () => {
          newArr[index]["frontImagePreview"] = reader.result;
          setAgeRangeArr(newArr);
        };
        dispatch(
          uploadAgeGroupImage({
            params: file,
            callback: (res: any) => {
              if (res?.data) {
                newArr[index][key] = res?.data?.name;
                setAgeRangeArr(newArr);
              }
            },
            errorCallback: (error: any) => { },
          })
        );
        reader.readAsDataURL(file);

      }
    } else if (key === "backImage") {
      if (!validateIsFileImageType(val)) {
        return;
      } else {
        const reader = new FileReader();
        const file = val.target.files[0];
        if (!mediaTypes.includes(file.type)) {
          console.error("Unsupported file type:", file.type);
          return;
        }
        reader.onloadend = () => {
          newArr[index]['backImagePreview'] = reader.result;
          setAgeRangeArr(newArr);
        };
        dispatch(
          uploadAgeGroupImage({
            params: file,
            callback: (res: any) => {
              if (res?.data) {
                newArr[index][key] = res?.data?.name;
                setAgeRangeArr(newArr);
              }
            },
            errorCallback: (error: any) => { },
          })
        );
        reader.readAsDataURL(file);

      }
    } else if (key === "name") {
      if (validateAgeGrp(val)) {
        newArr[index][key] = val;
        setAgeRangeArr(newArr);
      }
    } else if (key === "ageGroup") {
      newArr[index][key] = val;
      setAgeRangeArr(newArr);
    } else if (key === "order") {
      if (validateAgeGrp(val)) {
        newArr[index][key] = val;
        setAgeRangeArr(newArr);
      }
    } else if (key === "seoName") {
      newArr[index][key] = val;
      setAgeRangeArr(newArr);
    }
  }

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const updatedProduct = ageRangeArr.map((item: any) => { const { frontImagePreview, backImagePreview, ...rest } = item; return rest });
    if (validations()) {
      return;
    } else {
      const postData = {
        book: updatedProduct,
      };
      dispatch(
        addAgeGroup({
          params: postData,
          callback: (res: any) => {
            if (res.status === "success") {
              dispatch(showSnackbar({ message: res?.msg, type: res?.type }));
              setTimeout(() => {
                hideSnackbar();
              }, 5000);
              setAgeRangeArr(initialVal);
            }
          },
          errorCallback: (error: any) => {
            dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          },
        })
      );
    }
  };

  const validationAgeGrp = () => {
    let agrGtrpFormatArr: boolean = false;
    ageRangeArr?.map((item: any) => {
      if (
        item?.name === "" ||
        item?.ageGroup === "" ||
        item?.order === "" ||
        item?.seoName === "" ||
        item?.frontImagePreview === "" ||
        item?.backImagePreview === ""
      ) {
        agrGtrpFormatArr = true;
      }
    });
    return agrGtrpFormatArr;
  };

  const validations = () => {
    return validationAgeGrp();
  };

  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle name={"Create Age Group"} />
      </div>
      <div className="formDiv">
        <form onSubmit={handleSubmit}>
          {ageRangeArr.map((item: any, index: any) => {
            return (
              <div className="d-flex mt-2 bxshadow p-3 borderRadius mb-4 w-75 position-relative">
                <div className="row">
                  <div className="col-md-3 mb-3">
                    <LabelInput
                      labelName={"Enter age group "}
                      isRequired
                    />
                    <InputField
                      key={"ex2"}
                      placeholder={"Enter Range(0-2) "}
                      setInputText={(value: any) =>
                        onchangeRange(value, index, "name")
                      }
                      value={item?.name}
                      maxLength={5}
                    />
                  </div>
                  <div className="col-md-3 mb-3">
                    <LabelInput labelName={"Enter description"} isRequired
                    />
                    <InputField
                      key={"ex2"}
                      placeholder={"Enter description"}
                      setInputText={(value: any) =>
                        onchangeRange(value, index, "ageGroup")
                      }
                      value={item?.ageGroup}
                    />
                  </div>
                  <div className="col-md-3 mb-3">
                    <LabelInput labelName={"SEO Name"} isRequired />
                    <InputField
                      key={"ex2"}
                      placeholder={"Enter SEO Name"}
                      setInputText={(value: any) =>
                        onchangeRange(value, index, "seoName")
                      }
                      value={item?.seoName}
                      maxLength={50}
                    />
                  </div>
                  <div className="col-md-3 mb-3">
                    <LabelInput labelName={"Order number"} isRequired />
                    <InputField
                      // key={"ex2"}
                      placeholder={`Order  No. ${index + 1}`}
                      setInputText={(value: any) =>
                        onchangeRange(value, index, "order")
                      }
                      value={item.order}
                      maxLength={2}
                    />
                  </div>
                  <div className="col-md-2 mb-3">
                    <LabelInput labelName={"front Image"} isRequired />
                    <ImagePickerAndViewer
                      value={item?.frontImagePreview}
                      handleChange={(value: any) => (onchangeRange(value, index, "frontImage"))}
                      htmlFor={`frontImage-upload-${index}`}
                      doctype={""} />
                  </div>
                  <div className="col-md-2 mb-3">
                    <LabelInput labelName={"back Image"} isRequired />
                    <ImagePickerAndViewer
                      value={item?.backImagePreview}
                      handleChange={(value: any) => (onchangeRange(value, index, "backImage"))}
                      htmlFor={`backImage-upload-${index}`}
                      doctype={""} />
                  </div>
                  {index === ageRangeArr.length - 1 && (
                    <div className="col-md-2 mb-3 position-relative">
                      <div className="position-absolute bottom-0">
                        <AddMoreBtn handleClick={onPressAdd} />
                      </div>
                    </div>
                  )}
                </div>
                {ageRangeArr.length === 1 ? null : (
                  <div className="col-1 position-absolute end-0">
                    <DeleteForeverIcon
                      className="cursor"
                      color="error"
                      fontSize="medium"
                      onClick={() => handleClose(index)}
                    />
                  </div>
                )}
              </div>
            );
          })}
          <div className="col-md-9 my-3">
            <div className="col-md-2 mx-auto">
              <Submitbtn name={"Submit"} disabled={validations()} />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AgeGroup;
